import type { DownloadOption } from 'js/src/components/common/video-downloads/DownloadOptionsGrid';

/**
 * How each download presents itself. The publish panel and the share page offer the same
 * artifacts, so the copy, icon and file type live here once; each surface supplies the behaviour
 * (what it does, whether it is available) that differs between them.
 */
export const DOWNLOAD_OPTION_DEFINITIONS = {
    video: {
        id: 'video',
        icon: 'download',
        text: 'Video',
        hint: '.mp4',
        description: 'Download the rendered video.',
    },
    carouselImages: {
        id: 'carousel-images',
        icon: 'photo_library',
        text: 'Carousel',
        hint: '.zip',
        description:
            'Download each scene as an image to use in carousels. Works with LinkedIn, Instagram and Twitter.',
    },
    gif: {
        id: 'gif',
        icon: 'gif_box',
        text: 'GIF',
        hint: '.gif',
        description: 'Download your video as an animated GIF, ready to drop into an email or chat.',
    },
    audio: {
        id: 'audio',
        icon: 'audio_file',
        text: 'Audio',
        hint: '.wav',
        description: 'Download the audio track for your video, including music and voiceover.',
    },
    captionsSrt: {
        id: 'captions-srt',
        icon: 'closed_caption',
        text: 'Captions',
        hint: '.srt',
        description:
            'Download subtitles as an SRT file, the format most social platforms and video players accept.',
    },
    captionsVtt: {
        id: 'captions-vtt',
        icon: 'closed_caption',
        text: 'Captions',
        hint: '.vtt',
        description: 'Download subtitles as a WebVTT file, used for captions on the web.',
    },
    currentFrame: {
        id: 'frame',
        icon: 'photo_camera',
        text: 'Current frame',
        description: 'Download the frame currently shown in the player as a .png image.',
    },
} as const satisfies Record<
    string,
    Omit<DownloadOption, 'inProgress' | 'onClick' | 'hint'> & { hint?: string }
>;
